// extracted by mini-css-extract-plugin
export default {"label":"CheckboxGroupComponent_label__AIwDK"};